import React, { useEffect } from "react";
import backgroundimg from "./../image/banner.png";
import { useStateValue } from "../context/StateProvider";
import { fetchBlogs } from "../utils/firebaseFunctions"; // ✅ Import fetch function
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import moment from "moment"; 
import { CalendarDays } from "lucide-react";
const ViewBlogs = ({showBanner = true, limitBlogs,className = ""   }) => {
  const [{ Blog }, dispatch] = useStateValue();


  useEffect(() => {
    if (!Blog || Blog.length === 0) {
      fetchBlogs(dispatch);
    }
  }, [Blog, dispatch]);

  // Show only the first `limitBlogs` items if `limitBlogs` is passed
  const displayedBlogs = limitBlogs ? Blog.slice(0, limitBlogs) : Blog;

  return (
    <div className={`w-full h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0 ${className}`}>
      {/* Meta Tags for SEO */}
      {!limitBlogs && (
      <Helmet>
    <title>Our Blogs - Nexify Infosystems</title>

        <meta
          name="description"
          content="Stay updated with the latest insights, trends, and news from Nexify Infosystems. Explore our blogs on technology, business solutions, and innovation."
        />
        <meta
          name="keywords"
          content="Nexify, blogs, technology insights, business trends, innovation, IT solutions"
        />
      </Helmet>
    )}

      {showBanner && (
        <div
          className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
          style={{ backgroundImage: `url(${backgroundimg})` }}
        >
          <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
            <div
              className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
              style={{
                animation: "slideUp 1s ease-in-out forwards",
                animationDelay: "2s",
              }}
            >
              <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>
              <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2">Nexify Blogs</h1>
              <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
                Insights & Innovations for Your Business Growth
              </h2>
            </div>
          </div>
        </div>
      )}

      {/* Blog Section */}
      <div className="bg-white flex flex-col items-center text-left p-6 w-full max-w-[1320px] mt-5 gap-6 mb-20">
        <h2 className="text-[#0e55a8] text-[30px] font-[700] text-center">
          Our Blogs
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
        {displayedBlogs.length > 0 ? (
  displayedBlogs.map((blog) => (
    <motion.div
      key={blog.id}
      whileHover={{ scale: 1.05 }}
      className="bg-white shadow-lg rounded-lg overflow-hidden p-4 border border-gray-200"
    >
      <Link to={`/blog/${blog.id}`}>
        <div className="w-full h-48 md:h-56 overflow-hidden rounded-md">
          <img src={blog.imageurl} alt={blog.title} className="w-full h-full object-cover" />
        </div>

        <h3 className="text-[20px] font-semibold mt-4 text-gray-900">{blog.title}</h3>
        <div className="flex items-center gap-2 text-gray-600 text-sm mt-1">
                    <CalendarDays size={18} className="text-gray-500" /> 
                    <span>{moment(blog.date).format("DD-MM-YYYY")}</span> 
                  </div>          
        <p className="text-[#6d6d70] mt-3 text-left text-[14px]">
          {blog.description.length > 100
            ? blog.description.substring(0, 100) + "..."
            : blog.description}
        </p>
      </Link>
    </motion.div>
  ))
) : (
  <div className="w-full flex justify-center">
  <p className="text-gray-500 text-center">No Blogs available</p>
</div>
)}
        </div>

         {/* Show "Read More" button only in the main container */}
         {limitBlogs && (
          <div className="w-full flex justify-center mt-4">
          <a
            href="/blogs"
            className="bg-gradient-to-r from-blue-500 to-purple-600 text-white hover:from-purple-600 hover:to-blue-500 transition duration-300 px-6 py-2 rounded-md text-[15px] shadow-md 
                        hover:scale-105"
          >
            Read More
          </a>
        </div>
        
        )}
      </div>
    </div>
  );
};

export default ViewBlogs;
